import { apiClient } from 'v4/core/apiClient';
import { createIntegrationApi } from './integration.api.http';

export const myIntegrationApi = createIntegrationApi(apiClient);
